import { render, staticRenderFns } from "./FeatureIcon.vue?vue&type=template&id=64a8d432&"
import script from "./FeatureIcon.vue?vue&type=script&lang=js&"
export * from "./FeatureIcon.vue?vue&type=script&lang=js&"
import style0 from "./FeatureIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports